import React, { useEffect, useState } from "react";
import { Sparkle } from "lucide-react";

// New Image Imports based on your provided names
import ADHD from "../assets/tracks/ADHD.jpg";
import Al_Digital_Psychiatry from "../assets/tracks/AI_Digital_Psychiatry.jpg";
import Alzheimers from "../assets/tracks/Alzheimers.jpg";
import Autism_Research from "../assets/tracks/Autism_Research.jpg";
import Behavioural_Science from "../assets/tracks/Behavioural_Science.jpg";
import Genetic_Research from "../assets/tracks/genetic_research.jpg"; // Assuming this is for "Brain Function"
import Dementia from "../assets/tracks/Dementia.jpg";
import Education_for_autism from "../assets/tracks/Education_for_autism.jpg"; // Assuming this is for "Education"
import Forensic_Neuropsychiatry from "../assets/tracks/Forensic_Neuropsychiatry.jpeg";
import Mental_Health from "../assets/tracks/Mental_Health.jpg";
import Neurobiology from "../assets/tracks/Neurobiology.png";
import Neurogenetics from "../assets/tracks/Neurogenetics.jpg";
import Neuroscience from "../assets/tracks/Neuroscience.jpg";
import Pharmacological_Interventions from "../assets/tracks/Pharmacological_Interventions.jpg";
import Psychiatry from "../assets/tracks/Psychiatry.jpg";
import Psychopharmacology from "../assets/tracks/Psychopharmacology.jpg";
import Public_Health from "../assets/tracks/Public_Health.jpg";
import Rehabilitation from "../assets/tracks/Rehabilitation.jpg";
import Sleep_Disorders from "../assets/tracks/Sleep_Disorders.jpg";
import Trauma from "../assets/tracks/Trauma.jpg";

export const tracks = [
  {
    image: Autism_Research,
    title: "Autism Research",
    subtitle: "Advancing Insights in Autism Care",
    description:
      "Autism Research explores genetic, neurological, and behavioral foundations to improve diagnosis and treatment. Innovative studies focus on Early Detection, Social Communication, Sensory Processing, and Personalized Therapies. It bridges Neuroscience with real-world applications to enhance Quality of Life for individuals on the spectrum, fostering better support systems.",
  },
  {
    image: ADHD,
    title: "ADHD",
    subtitle: "Understanding and Managing ADHD",
    description:
      "ADHD Research investigates Attention Regulation, Impulsivity, and Hyperactivity across age groups. Studies emphasize Neurobiological Mechanisms, Behavioral Interventions, and Medication Strategies. Ongoing work explores Comorbidities, Executive Functioning, and how Lifestyle and Environment influence outcomes, especially in Academic and Social Contexts for effective management.",
  },
  {
    image: Trauma,
    title: "Trauma",
    subtitle: "The Neuroscience of Trauma",
    description:
      "Trauma affects Brain Circuitry, Memory, and Emotional Regulation. Current Research delves into PTSD, Complex Trauma, and the impact of Early Adversity. By studying Neural Changes and Psychological Symptoms, Experts develop therapies like EMDR and Trauma-Informed Care. Understanding Trauma’s effects leads to better Clinical Outcomes and support systems for recovery.",
  },
  {
    image: Neuroscience,
    title: "Neuroscience",
    subtitle: "Unlocking the Brain’s Mysteries",
    description:
      "Neuroscience studies the Brain and Nervous System, revealing how Neurons communicate and how Cognition, Behavior, and Emotions emerge. Advancements in Neuroimaging, Neuroplasticity, and AI-driven Models are transforming understanding of Brain Function and Dysfunction, offering insights into treatment for Neurological and Psychiatric Disorders.",
  },
  {
    image: Public_Health,
    title: "Public Health",
    subtitle: "Mental Health in Public Health",
    description:
      "Public Health initiatives address Mental Health at population levels through Policy, Prevention, and Intervention Strategies. Emphasis is on Social Determinants, Community Resilience, Access to Care, and Reducing Stigma. Integrated Mental Health Services enhance outcomes and promote Well-being in diverse and underserved populations Globally, ensuring equitable care.",
  },
  {
    image: Behavioural_Science,
    title: "Behavioral Science",
    subtitle: "Behavioral Science in Mental Care",
    description:
      "Behavioral Science examines how Thoughts, Emotions, and Actions are shaped by Biology and Environment. It informs interventions in Education, Therapy, and Public Health by analyzing Behavior Patterns and Decision-Making Processes. It also plays a vital role in designing Behavior Change Models for Mental Health Promotion.",
  },
  {
    image: Psychiatry,
    title: "Psychiatry",
    subtitle: "Modern Innovations in Psychiatry",
    description:
      "Psychiatry focuses on diagnosing and treating Mental, Emotional, and Behavioral Disorders. Advances in Brain Imaging, Personalized Medicine, and Psychopharmacology have revolutionized care. Emerging areas like Digital Psychiatry and Genetic Profiling are reshaping Psychiatric Practice, offering targeted and effective Treatment Strategies for improved patient outcomes.",
  },
  {
    image: Mental_Health,
    title: "Mental Health",
    subtitle: "The Evolving Scope of Mental Health",
    description:
      "Mental Health includes Emotional, Psychological, and Social Well-being. It affects how individuals think, feel, and act. Current efforts aim to Destigmatize Mental Illness, expand Access to Therapy, and integrate Mental Wellness into daily life. Digital Tools and Policy Reform are also central to this progress.",
  },
  {
    image: Alzheimers,
    title: "Alzheimer’s",
    subtitle: "Tackling the Alzheimer’s Epidemic",
    description:
      "Alzheimer’s Research seeks to understand Neurodegeneration, Plaque Formation, and Memory Loss associated with the disease. Innovative Therapies aim to slow Progression, improve Cognition, and enhance Patient Care. Genetics, Lifestyle, and Early Detection Methods are central to preventing and managing this growing Public Health Challenge effectively.",
  },
  {
    image: Rehabilitation,
    title: "Rehabilitation",
    subtitle: "Neurological Rehabilitation Today",
    description:
      "Rehabilitation Science aids recovery from Brain Injury, Stroke, or chronic conditions like MS and Parkinson’s. Multidisciplinary Approaches use Physical, Cognitive, and Emotional Therapies to restore function. Technology like Robotics, VR, and Neurofeedback is enhancing Neurorehabilitation Outcomes and Patient Quality of Life through innovative interventions.",
  },
  {
    image: Dementia,
    title: "Dementia",
    subtitle: "Advancing Dementia Diagnosis & Care",
    description:
      "Dementia affects Memory, Thinking, and Behavior, often in aging populations. Research targets Early Detection, Risk Reduction, and Compassionate Care Models. Personalized Therapy, Cognitive Training, and Lifestyle Interventions offer hope in managing Symptoms and improving life for Patients and Caregivers, promoting better well-being.",
  },
  {
    image: Pharmacological_Interventions,
    title: "Pharmacological Interventions",
    subtitle: "Drug Therapies in Mental Health",
    description:
      "Pharmacological Interventions use Medications to treat Psychiatric and Neurological Disorders. From Antidepressants to Antipsychotics, ongoing Research refines Dosing, reduces Side Effects, and develops Novel Drugs. Precision Medicine and Biomarker-Based Approaches are transforming how Mental Illnesses are managed Pharmacologically for optimal patient safety.",
  },
  {
    image: Psychopharmacology,
    title: "Psychopharmacology",
    subtitle: "Psychopharmacology and Brain Health",
    description:
      "Psychopharmacology studies how Drugs affect Mood, Behavior, and Cognition. It guides Psychiatric Treatment by exploring Drug Mechanisms, Efficacy, and Interactions. Innovations include Long-Acting Injectables, Novel Antidepressants, and Psychedelic-Assisted Therapy, reshaping how Clinicians approach Mental Illness Pharmacologically for better Brain Health outcomes.",
  },
  {
    image: Sleep_Disorders,
    title: "Sleep Disorders",
    subtitle: "Sleep Health and Mental Wellness",
    description:
      "Sleep Disorders such as Insomnia, Apnea, and Narcolepsy impact Mental and Physical Health. Research connects disrupted sleep to Depression, Anxiety, and Cognitive Decline. Treatments include Behavioral Therapy, Pharmacology, and Sleep Hygiene Education, emphasizing sleep’s crucial role in Overall Well-being and mental restoration.",
  },
  {
    image: Neurogenetics,
    title: "Neurogenetics",
    subtitle: "Genetics Behind Brain Disorders",
    description:
      "Neurogenetics explores how Genes influence Brain Development, Function, and Disease Risk. It uncovers links to conditions like Autism, Schizophrenia, and Epilepsy. Through Gene Mapping and Molecular Biology, scientists aim to Predict, Prevent, and Personalize Treatments for Neurological and Psychiatric Conditions, advancing Precision Medicine.",
  },
  {
    image: Al_Digital_Psychiatry,
    title: "AI and Digital Psychiatry",
    subtitle: "AI’s Role in Future Psychiatry",
    description:
      "AI and Digital Tools are revolutionizing Psychiatry by enabling Predictive Analytics, Virtual Care, and Real-time Mental Health Monitoring. Chatbots, Machine Learning Models, and Mobile Health Apps personalize Treatment and improve Accessibility. Ethical AI Use ensures equitable and effective care in Mental Health Systems for broader impact.",
  },
  {
    image: Genetic_Research, // Mapped to 'Brain Function' as it's the most apt based on title
    title: "Genetic Research",
    subtitle: "Decoding Life Through Genes",
    description:
      "Genetic Research uncovers how DNA, Genes, and Genomics influence traits, health, and disease in humans, animals, and plants. Explore breakthroughs in Gene Editing, CRISPR Technology, and Genetic Engineering. Discover how Genomics transforms Precision Medicine, agriculture, and evolution studies. Submit abstracts advancing the future of Molecular Biology and Genetic Science",
  },
  {
    image: Neurobiology, // Mapped to 'Neurobiology'
    title: "Neurobiology",
    subtitle: "The Biology of Brain Behavior",
    description:
      "Neurobiology focuses on the Cellular and Molecular Mechanisms of the Nervous System. It examines Neuron Structure, Synaptic Transmission, and Neurodevelopment. Insights into Neurobiology help explain Mental Disorders and inform Therapeutic Strategies from Medications to Neurostimulation Technologies, significantly advancing Brain Behavior understanding.",
  },
  {
    image: Forensic_Neuropsychiatry,
    title: "Forensic Neuropsychiatry",
    subtitle: "Brain Science in Legal Contexts",
    description:
      "Forensic Neuropsychiatry merges Brain Science with Legal Issues. It investigates the Mental State of Defendants, Criminal Behavior, and Cognitive Capacity in Legal Settings. Brain Imaging, Psychological Evaluation, and Neurogenetics aid in understanding Criminal Responsibility and Rehabilitation Potential, ensuring a balanced legal and medical approach.",
  },
  {
    image: Education_for_autism,
    title: "Autism Education",
    subtitle: "Neuroscience and Learning Science",
    description:
      "Neuroscience in Education studies how the Brain Learns, Remembers, and Adapts. Insights support Personalized Teaching, Inclusive Classrooms, and Interventions for Learning Disabilities. It bridges Cognitive Psychology with Pedagogy, enhancing outcomes through Brain-Based Educational Strategies and Emotional Learning Support for all learners.",
  },
];

const StaticTracks = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <style>{`
        @keyframes pulseShadow {
          0%, 100% {
            box-shadow: 0 0 0px rgba(44, 211, 35, 0.2);
          }
          50% {
            box-shadow: 0 0 18px 6px rgb(122,179,38);
          }
        }

        .animate-pulseShadow {
          animation: pulseShadow 3s ease-in-out infinite;
        }

        .transition-custom {
          transition: all 0.8s ease-in-out;
        }
      `}</style>

      <div className="relative mt-14">
        {/* Fixed Top-Right Button */}
        <div className="fixed top-[22%] right-[1%] z-50 transition-custom">
          <a
            href="/abstract-submission"
            aria-label="Submit abstract"
            className="bg-one rounded-full text-white text-sm font-medium px-3 py-3 select-none transition-transform hover:scale-110 animate-pulseShadow"
          >
            Submit Abstract
          </a>
        </div>

        {/* Track Content */}
        <div className="container mx-auto px-4 py-10 space-y-20 flex flex-col items-center">
          {tracks.map((track, index) => (
            <div
              key={index}
              className="relative w-[80%] flex flex-col md:flex-row items-stretch md:space-x-6"
            >
              <div className="flex-shrink-0 bg-white border shadow-xl rounded-2xl p-2 w-full md:w-1/3">
                <img
                  src={track.image}
                  alt={track.title}
                  className="w-full h-full object-cover rounded-xl"
                  loading="lazy"
                />
              </div>
              <div className="bg-white border shadow-xl rounded-2xl p-6 w-full md:w-2/3 mt-12 md:mt-0 flex flex-col justify-center">
                <h2 className="text-3xl font-bold mb-1 text-one flex items-center gap-2">
                  <Sparkle className="fill-one" />
                  {track.title}
                </h2>
                <h3 className="text-xl text-gray-600 font-semibold mb-3">
                  {track.subtitle}
                </h3>
                <p className="text-md text-gray-800 leading-relaxed">
                  {track.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default StaticTracks;
